import React, { useState, useEffect } from 'react';
import logoUrl from '../assets/opsmaticz_logo.png';

/* ── Inline SVG Icons (Lucide-style) ── */
const Icon = ({ d, size = 18, strokeWidth = 2.5 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {Array.isArray(d) ? d.map((path, i) => <path key={i} d={path} />) : <path d={d} />}
  </svg>
);

const icons = {
  dashboard: ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
  operators: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75', 'M9 7m-4 0a4 4 0 1 0 8 0 4 4 0 1 0-8 0'],
  tickets: ['M3 18v-6a9 9 0 0 1 18 0v6', 'M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z'],
  pricePlans: ['M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'],
  globe: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M2 12h20', 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z'],
  conversations: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  subscription: ['M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3z'],

  settings: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'],
  finance: ['M8 7.5a4 4 0 1 0 8 0 4 4 0 1 0-8 0', 'M8 12a4 4 0 1 0 8 0', 'M8 16.5a4 4 0 1 0 8 0'],
  email: ['M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', 'M22 6l-10 7L2 6'],
  masterData: ['M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z'],
  users: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  fleet: ['M7 17m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0', 'M17 17m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0', 'M5 17H3V7c0-1.1.9-2 2-2h11v12h-2', 'M19 17h2v-6l-3-4h-2v7h4'],
  maintenance: ['M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z'],
  vendors: ['M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4H6z', 'M3 6h18', 'M16 10a4 4 0 0 1-8 0'],
  drivers: ['M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M17 11l2 2 4-4'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'M16 17l5-5-5-5', 'M21 12H9'],
  phone: ['M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'],
  mail: ['M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', 'M22 6l-10 7L2 6'],
  message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  telegram: ['M22 2L11 13', 'M22 2l-7 20-4-9-9-4 20-7z'],
  whatsapp: ['M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-7.6 8.38 8.38 0 0 1 3.8.9L21 4.5z'],
  tripOperations: ['M3 11l19-9-9 19-2-8-8-2z'],
  chevron: 'M6 9l6 6 6-6',
  building: ['M3 21h18', 'M3 7v1a3 3 0 0 0 6 0V4', 'M9 8a3 3 0 0 0 6 0V4', 'M15 8a3 3 0 0 0 6 0V7H3'],
  bank: ['M3 21h18', 'M3 10h18', 'M5 6l7-3 7 3', 'M4 10v11', 'M20 10v11', 'M8 14v3', 'M12 14v3', 'M16 14v3'],
  profile: ['M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', 'M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z'],
};

const ADMIN_NAV = [
  { iconKey: 'dashboard', label: 'Dashboard', pageKey: 'dashboard', permission: 'View Dashboard' },
  {
    iconKey: 'operators', label: 'Operators', expandable: true, permission: 'View Operators',
    children: [
      { label: 'Manage Operators', pageKey: 'manage-operators', permission: 'View Operators' },
    ],
  },
  {
    iconKey: 'subscription', label: 'Subscriptions', expandable: true, permission: 'View Subscriptions',
    children: [
      { label: 'Manage Subscription', pageKey: 'manage-subscriptions', permission: 'View Subscriptions' },
      { label: 'Update Requests', pageKey: 'admin-update-requests', permission: 'View Subscriptions' },
    ],
  },
  { iconKey: 'pricePlans', label: 'Price Plans', pageKey: 'price-plans', permission: 'View Price Plans' },
  { iconKey: 'globe', label: 'Countries', pageKey: 'countries', permission: 'View Countries' },
  { iconKey: 'tickets', label: 'Tickets', pageKey: 'tickets', permission: 'View Tickets' },
  {
    iconKey: 'email', label: 'Email Templates', expandable: true, permission: 'View Email Templates',
    children: [
      { label: 'Manage Templates', pageKey: 'manage-templates', permission: 'View Email Templates' },
    ],
  },
  { iconKey: 'users', label: 'Users', pageKey: 'users', permission: 'View Users' },
  {
    iconKey: 'settings', label: 'Settings', expandable: true, permission: 'Manage Settings',
    children: [
      { label: 'Settings Dashboard', pageKey: 'settings', permission: 'Manage Settings' },
      { label: 'General Settings', pageKey: 'general-settings', permission: 'Manage Settings' },
      { label: 'Route Settings', pageKey: 'route-settings', permission: 'Manage Settings' },
      { label: 'Ticket Settings', pageKey: 'ticket-settings', permission: 'Manage Settings' },
      { label: 'SMTP Settings', pageKey: 'smtp-settings', permission: 'Manage Settings' },
      { label: 'Master Data', pageKey: 'master-data', permission: 'Manage Settings' },
      { label: 'Expense Categories', pageKey: 'expense-categories', permission: 'Manage Settings' },
    ],
  },
];

const OPERATOR_NAV = [
  { iconKey: 'dashboard', label: 'Dashboard', pageKey: 'operator-dashboard', permission: 'View Dashboard' },
  {
    iconKey: 'finance', label: 'Finance', expandable: true, permission: 'View Finance',
    children: [
      { label: 'Financial Dashboard', pageKey: 'financial-dashboard', permission: 'View Finance' },
      { label: 'Invoice', pageKey: 'operator-invoices', permission: 'Manage Invoices' },
      { label: 'Quotations', pageKey: 'operator-quotations', permission: 'Manage Quotations' },
      { label: 'Expenses', pageKey: 'operator-expenses', permission: 'Manage Expenses' },
      { label: 'Bank Accounts', pageKey: 'bank-accounts', permission: 'Manage Bank Accounts' },
      { label: 'Petty Cash', pageKey: 'petty-cash', permission: 'Manage Petty Cash' },
    ],
  },
  {
    iconKey: 'tripOperations', label: 'Trip Operations', expandable: true, permission: 'View Trip Operations',
    children: [
      { label: 'Routes', pageKey: 'routes', permission: 'Manage Routes' },
      { label: 'Route Stops', pageKey: 'route-stops', permission: 'Manage Route Stops' },
      { label: 'Trips', pageKey: 'trips', permission: 'Manage Trips' },
      { label: 'Availability', pageKey: 'availability', permission: 'Manage Availability' },
      { label: 'Passenger Allocation', pageKey: 'passenger-allocation', permission: 'Manage Passenger Allocation' },
      { label: 'Trip Reports', pageKey: 'trip-reports', permission: 'View Trip Reports' },
      { label: 'Adhoc Trips', pageKey: 'adhoc-trips', permission: 'Manage Adhoc Trips' },
      { label: 'Shuttle with Booking', pageKey: 'shuttle-booking', permission: 'Manage Shuttle Booking' },
      { label: 'Manage Trip Notifications', pageKey: 'manage-trip-notifications', permission: 'Manage Trip Operations' },
    ],
  },
  {
    iconKey: 'fleet', label: 'Fleet Management', expandable: true, permission: 'View Fleet',
    children: [
      { label: 'Fleet Dashboard', pageKey: 'fleet-dashboard', permission: 'View Fleet' },
      { label: 'All Vehicles', pageKey: 'all-vehicles', permission: 'Manage Vehicles' },
      { label: 'Cost Analysis', pageKey: 'vehicle-cost-analysis', permission: 'View Cost Analysis' },
      { label: 'Driver Vehicle Mapping', pageKey: 'driver-vehicle-mapping', permission: 'Manage Driver Vehicle Mapping' },
    ],
  },
  {
    iconKey: 'maintenance', label: 'Fleet Maintenance', expandable: true, permission: 'View Maintenance',
    children: [
      { label: 'Overview', pageKey: 'maintenance-overview', permission: 'View Maintenance' },
      { label: 'Fuel Management', pageKey: 'fuel-management', permission: 'Manage Fuel' },
      { label: 'Workshop/Vendor', pageKey: 'maintenance-workshop-vendor', permission: 'Manage Workshops' },
      { label: 'Job Maintenance', pageKey: 'maintenance-jobs', permission: 'Manage Jobs' },
      { label: 'Tyres & Battery', pageKey: 'tyres-battery', permission: 'Manage Tyres' },
      { label: 'Compliance', pageKey: 'compliance', permission: 'Manage Compliance' },
      { label: 'Reports', pageKey: 'maintenance-reports', permission: 'View Maintenance Reports' },
    ],
  },
  {
    iconKey: 'drivers', label: 'Drivers', expandable: true, permission: 'View Drivers',
    children: [
      { label: 'Manage Drivers', pageKey: 'drivers', permission: 'Manage Drivers' },
      { label: 'Attendance', pageKey: 'driver-attendance', permission: 'Manage Attendance' },
      { label: 'Driver Salary Logs', pageKey: 'driver-salary-logs', permission: 'Manage Salary Logs' },
    ],
  },
  {
    iconKey: 'vendors', label: 'Vendors', expandable: true, permission: 'View Vendors',
    children: [
      { label: 'Vendor Dashboard', pageKey: 'vendor-dashboard', permission: 'View Vendors' },
      { label: 'Vendor Management', pageKey: 'vendors', permission: 'Manage Vendors' },
      { label: 'Vendor Drivers', pageKey: 'vendor-drivers', permission: 'Manage Vendor Drivers' },
      { label: 'Fleet', pageKey: 'vendor-fleet', permission: 'Manage Vendor Fleet' },
      { label: 'Documents', pageKey: 'vendor-documents', permission: 'Manage Vendor Documents' },
      { label: 'Contracts', pageKey: 'vendor-contracts', permission: 'Manage Vendor Contracts' },
      { label: 'Pricing', pageKey: 'vendor-pricing', permission: 'Manage Vendor Pricing' },
    ],
  },
  {
    iconKey: 'building', label: 'Clients', expandable: true, permission: 'View Clients',
    children: [
      { label: 'Manage Clients', pageKey: 'manage-clients', permission: 'Manage Clients' },
      { label: 'Passenger Limits', pageKey: 'client-passenger-limits', permission: 'Manage Clients' },
    ],
  },
  { iconKey: 'maintenance', label: 'Request Plan Update', pageKey: 'request-update', permission: 'View Dashboard' },
  { iconKey: 'tickets', label: 'Support Tickets', pageKey: 'support-tickets', permission: 'View Support Tickets' },
  { iconKey: 'users', label: 'Users', pageKey: 'users', permission: 'View Users' },
  {
    iconKey: 'settings', label: 'Settings', expandable: true, permission: 'Manage Settings',
    children: [
      { label: 'Settings Dashboard', pageKey: 'settings', permission: 'Manage Settings' },
      { label: 'General Settings', pageKey: 'general-settings', permission: 'Manage Settings' },
      { label: 'Route Settings', pageKey: 'route-settings', permission: 'Manage Settings' },
      { label: 'Ticket Settings', pageKey: 'ticket-settings', permission: 'Manage Settings' },
      { label: 'SMTP Settings', pageKey: 'smtp-settings', permission: 'Manage Settings' },
      { label: 'Master Data', pageKey: 'master-data', permission: 'Manage Settings' },
      { label: 'Expense Categories', pageKey: 'expense-categories', permission: 'Manage Settings' },
      { label: 'Petty Cash Setup', pageKey: 'petty-cash-setup', permission: 'Manage Settings' },
      { label: 'Service Types', pageKey: 'service-types', permission: 'Manage Service Types' },
    ],
  },
];

export default function Sidebar({ activePage, onNavigate, user, onLogout, operatorDetails }) {
  const isSuperadmin = user?.userType === 'admin' && (!user.role || user.role === 'System Admin' || user.role === 'Superadmin');
  const hasPermission = (perm) => {
    if (isSuperadmin) return true;
    if (user?.userType === 'operator' && user?._id === user?.operatorId) return true;
    if (!perm) return true;
    return user?.permissions?.includes(perm);
  };

  const baseNavItems = user?.userType === 'operator' ? OPERATOR_NAV : ADMIN_NAV;
  
  // Filter nav items by permission
  const navItems = baseNavItems.map(item => {
    if (item.expandable && item.children) {
      const filteredChildren = item.children.filter(child => hasPermission(child.permission));
      if (filteredChildren.length > 0 && hasPermission(item.permission)) {
        return { ...item, children: filteredChildren };
      }
      return null;
    }
    return hasPermission(item.permission) ? item : null;
  }).filter(Boolean);


  const [openMenus, setOpenMenus] = useState(() => {
    const initial = {};
    navItems.forEach(item => {
      if (item.expandable && (
        item.children?.some(c => c.pageKey === activePage) ||
        (item.label === 'Operators' && activePage === 'manage-members')
      )) {
        initial[item.label] = true;
      }
    });
    return initial;
  });

  // Auto-open parent menus when a child page is active
  useEffect(() => {
    const baseNavItems = user?.userType === 'operator' ? OPERATOR_NAV : ADMIN_NAV;
    baseNavItems.forEach(item => {
      if (item.expandable && (
        item.children?.some(c => c.pageKey === activePage) ||
        (item.label === 'Operators' && activePage === 'manage-members')
      )) {
        setOpenMenus(prev => ({ ...prev, [item.label]: true }));
      }
    });
  }, [activePage, user?.userType]);

  const toggleMenu = (item) => {
    setOpenMenus(prev => ({ ...prev, [item.label]: !prev[item.label] }));
  };



  return (
    <aside className={`sidebar ${user?.userType === 'operator' ? 'operator-sidebar' : isSuperadmin ? 'superadmin-sidebar' : ''}`}>
      {/* Logo */}
      <div 
        className="sidebar-logo"
        onClick={() => onNavigate(user?.userType === 'operator' ? 'operator-profile' : 'profile')}
        style={{ 
          cursor: 'pointer', 
          padding: (user?.userType === 'operator' && operatorDetails?.companyLogo) ? '0px' : '18px 24px', 
          display: 'flex', 
          justifyContent: 'flex-start', 
          alignItems: 'center',
          background: '#ffffff', 
          borderBottom: '1px solid #f1f5f9',
          height: (user?.userType === 'operator' && operatorDetails?.companyLogo) ? '120px' : '72px'
        }}
      >
        <img 
          src={user?.userType === 'operator' && operatorDetails?.companyLogo 
            ? `/api/uploads/${operatorDetails.companyLogo}` 
            : logoUrl} 
          alt={user?.userType === 'operator' && operatorDetails?.companyName ? operatorDetails.companyName : "Opsmaticz"} 
          style={{ 
            width: 'auto', 
            height: 'auto',
            maxHeight: (user?.userType === 'operator' && operatorDetails?.companyLogo) ? '100%' : '46px', 
            maxWidth: '180px',
            objectFit: 'contain'
          }} 
        />
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          const isActive = item.pageKey === activePage ||
            (item.children && item.children.some(c => c.pageKey === activePage)) ||
            (item.label === 'Operators' && activePage === 'manage-members');
          const isOpen = openMenus[item.label];

          return (
            <React.Fragment key={i}>
              <div
                className={`nav-item${isActive ? ' active' : ''}`}
                onClick={() => {
                  if (item.expandable) {
                    toggleMenu(item);
                    if (item.children && item.children.length > 0 && !openMenus[item.label]) {
                      onNavigate(item.children[0].pageKey);
                    }
                  }
                  else if (item.pageKey) onNavigate(item.pageKey);
                }}
                style={{ cursor: 'pointer' }}
              >
                <span className="nav-icon">
                  <Icon d={icons[item.iconKey]} size={15} />
                </span>
                <span>{item.label}</span>
                {item.expandable && (
                  <span
                    className="nav-chevron"
                    style={{
                      marginLeft: 'auto',
                      display: 'inline-flex',
                      alignItems: 'center',
                      transition: 'transform 0.2s',
                      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  >
                    <Icon d={icons.chevron} size={12} />
                  </span>
                )}
              </div>

              {/* Sub-menu */}
              {item.expandable && isOpen && (
                <div className="nav-submenu">
                  {item.children.map((child, ci) => (
                    <div
                      key={ci}
                      className={`nav-item submenu-item${activePage === child.pageKey ? ' active' : ''}`}
                      onClick={(e) => { e.stopPropagation(); onNavigate(child.pageKey); }}
                    >
                      {child.label}
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </nav>

      {/* User */}
      <div className="sidebar-user">
        <div className="user-avatar">{user?.firstName?.charAt(0) || (user?.userType === 'operator' ? 'O' : 'U')}</div>
        <div className="user-info">
          <div className="user-name">{user?.firstName} {user?.lastName}</div>
          <div className="user-email">{user?.email || (user?.userType === 'operator' ? 'Operator' : 'Superadmin')}</div>
        </div>
        <button
          onClick={onLogout}
          className="sidebar-logout-btn"
          title="Logout"
        >
          <Icon d={icons.logout} size={16} />
        </button>
      </div>
    </aside>
  );
}
